import React from 'react';

interface MultiSelectPillsProps {
  options: Array<{
    value: string;
    label: string;
    icon: string;
    gradient?: boolean;
  }>;
  selectedValues: string[];
  onChange: (values: string[]) => void;
  title?: string;
  isMobile?: boolean;
}

export const MultiSelectPills: React.FC<MultiSelectPillsProps> = ({
  options,
  selectedValues,
  onChange,
  title,
  isMobile = false,
}) => {
  const toggleValue = (value: string) => {
    if (selectedValues.includes(value)) {
      onChange(selectedValues.filter((v) => v !== value));
    } else {
      onChange([...selectedValues, value]);
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
      }}
    >
      {title && (
        <span
          style={{
            fontSize: '14px',
            fontWeight: 500,
            color: '#1a1a1a',
            fontFamily: 'Inter, sans-serif',
          }}
        >
          {title}
        </span>
      )}
      <style>{`
        @keyframes gradient-shift {
          0% {
            background-position: 0% 50%;
          }
          50% {
            background-position: 100% 50%;
          }
          100% {
            background-position: 0% 50%;
          }
        }
      `}</style>
      <div
        style={{
          display: 'flex',
          gap: '6px',
          flexWrap: isMobile ? 'nowrap' : 'wrap',
          overflowX: isMobile ? 'auto' : 'visible',
          WebkitOverflowScrolling: isMobile ? 'touch' : 'auto',
        }}
      >
        {options.map((option) => {
          const isSelected = selectedValues.includes(option.value);

          if (option.gradient && isSelected) {
            // Gradient border style for special options (only when selected)
            return (
              <div
                key={option.value}
                style={{
                  padding: '2px',
                  background:
                    'linear-gradient(90deg, #ff6b9d, #c471ed, #4da9e6, #1d72b8, #4da9e6, #c471ed, #ff6b9d)',
                  backgroundSize: '300% 300%',
                  borderRadius: '8px',
                  animation: 'gradient-shift 10s ease infinite',
                  flexShrink: 0,
                }}
              >
                <button
                  onClick={() => toggleValue(option.value)}
                  style={{
                    padding: '6px 12px',
                    borderRadius: '6px',
                    border: 'none',
                    backgroundColor: '#EEF1F4',
                    color: '#1a1a1a',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: 500,
                    fontFamily: 'Inter, sans-serif',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    whiteSpace: 'nowrap',
                    flexShrink: 0,
                  }}
                >
                  <span>{option.icon}</span>
                  {option.label}
                </button>
              </div>
            );
          }

          return (
            <button
              key={option.value}
              onClick={() => toggleValue(option.value)}
              style={{
                padding: '6px 12px',
                borderRadius: '8px',
                border: isSelected ? '2px solid #1a1a1a' : '2px solid #EEF1F4',
                backgroundColor: isSelected ? '#EEF1F4' : '#fff',
                color: isSelected ? '#1a1a1a' : '#666',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: isSelected ? 500 : 400,
                fontFamily: 'Inter, sans-serif',
                transition: 'all 0.2s ease',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                whiteSpace: 'nowrap',
                flexShrink: 0,
              }}
            >
              <span>{option.icon}</span>
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};
